module.exports = __webpack_public_path__ + "static/media/icon_emoji.28c0e118.png";